module.exports = __webpack_public_path__ + "static/media/Engxg5.52e05a35.png";